import styled, { keyframes } from "styled-components"

const beatAnimation = keyframes`
  50% {transform: scale(0.75);opacity: 0.2}
  100% {transform: scale(1);opacity: 1}
`
const Beat = styled.span<{ size: number; index: 0 | 1 | 2 }>`
  display: inline-block;
  background-color: currentColor;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  margin: 0 ${(props) => props.index === 1 && "var(--size-1)"};
  border-radius: 100%;
  animation: ${beatAnimation} ${0.4}s
    ${(props) => (props.index % 2 ? `${0.2}s` : "0s")} infinite linear;
  animation-fill-mode: both;
`

const ThreeDotsLoader: React.FC<{ size?: number }> = ({ size = 12 }) => {
  return (
    <span>
      <Beat size={size} index={0} />
      <Beat size={size} index={1} />
      <Beat size={size} index={2} />
    </span>
  )
}
export default ThreeDotsLoader
